import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  AddCommentRequest,
  CommentsAPI,
  GetCommentsResponse,
  IComment,
} from "../../../api/comments";
import { showErrorToast, showSuccessToast } from "../../../lib/toast";

export const fetchCommentsThunk = createAsyncThunk<
  GetCommentsResponse,
  {
    case_id: string;
    thread_type: AddCommentRequest["thread_type"];
    entity_type: AddCommentRequest["entity_type"];
    entity_id: string;
  },
  { rejectValue: string }
>("comments/fetch", async (args, { rejectWithValue }) => {
  try {
    return await CommentsAPI.get(
      args.case_id,
      args.thread_type,
      args.entity_type,
      args.entity_id,
    );
  } catch (error: any) {
    return rejectWithValue(error?.message || "Failed to fetch comments");
  }
});

export const addCommentThunk = createAsyncThunk<
  IComment,
  { case_id: string; request: AddCommentRequest; commentor: string },
  { rejectValue: string }
>(
  "comments/add",
  async ({ case_id, request, commentor }, { rejectWithValue }) => {
    try {
      const response = await CommentsAPI.add(case_id, request);

      showSuccessToast("Comment added");

      return {
        comment_id: response.comment_id,
        commented_at: response.commented_at,
        comment: request.comment,
        commentor,
      };
    } catch (error: any) {
      const message = error?.message || "Failed to add comment";
      showErrorToast(message);
      return rejectWithValue(message);
    }
  },
);
